module.exports = __webpack_public_path__ + "img/locations.dfb81fdd.svg";